import { AfterContentChecked, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';


import { Reuniao } from 'src/app/core/reuniao';


@Component({
  selector: 'acao-reuniao',
  templateUrl: './acao-reuniao.component.html',
  styleUrls: ['./acao-reuniao.component.css']
})
export class AcaoReuniaoComponent implements OnInit, AfterContentChecked {

  @Input() reuniao: Reuniao;

  openFormCadastro = false;

  constructor(protected drc: ChangeDetectorRef) {
  }

  ngOnInit() {
  }

  ngAfterContentChecked(): void {
    this.drc.detectChanges();
  }

  onGetAdicionar(evento) {
    this.openFormCadastro = evento;
  }

}
